<template lang="pug">
    #modal-visualizar-protocolos-vinculados
        el-dialog(
            width='40%',
            title='Protocolos vinculados',
            :visible.sync='mostrar',
            :close-on-click-modal='false',
            :before-close='fechar'
        )
            main
                h3.mb-2 Empresa: {{ empresa.nomeEmpresa }}
                h3 Protocolos:
                ul(v-loading='buscandoProtocolos')
                    li(v-for='protocolo in protocolosVinculados') {{ protocolo.descricao }}

            footer(slot='footer')
                BaseButton(size='mini', @click='fechar') Voltar
</template>

<script>
    import { ProtocolosService } from '@/services/ProtocolosService';
    import BaseButton from '@/components/vegaComponents/BaseButton.vue';

    export default {
        name: 'ModalVisualizarProtocolosVinculados',

        components: {
            BaseButton
        },

        props: {
            mostrar: {
                type: Boolean,
                required: true
            },
            empresa: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                protocolosVinculados: [],
                buscandoProtocolos: false
            };
        },

        watch: {
            mostrar() {
                if (this.mostrar) {
                    this.buscarProtocolos();
                }
            }
        },

        methods: {
            async buscarProtocolos() {
                this.buscandoProtocolos = true;
                const protocolos = await ProtocolosService.buscarProtocolosPorEmpresa(
                    this.empresa.idEmpresa
                );
                this.protocolosVinculados = protocolos.data;
                this.buscandoProtocolos = false;
            },

            fechar() {
                this.protocolosVinculados = [];
                this.$emit('fechar');
            }
        }
    };
</script>
